function initSwiper() {

      if (window.location.pathname.includes('/ar') || window.location.pathname.includes('/he') || window.location.pathname.includes('/ur')) {
        $('.cart-slider').slick({
        speed: 800,
        loop: true,
        rtl: true,
        dots: true,
        slidesToShow: 1,  
        slidesToScroll: 1,
        arrows: false
    });
    } else {
       $('.cart-slider').slick({
        speed: 800,
        loop: true,
        dots: true,
        slidesToShow: 1,  
        slidesToScroll: 1,
        arrows: false
    });
    }
}
$(document).ready(function() {

  initSwiper();

  function initSwiper() {
    if (window.location.pathname.includes('/ar') || window.location.pathname.includes('/he') || window.location.pathname.includes('/ur')) {
      $('.cart-slider').slick({
        speed: 800,
        loop: true,
        rtl: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      });
    } else {
      $('.cart-slider').slick({
        speed: 800,
        loop: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      });
    }
  }

  function addToCartSuccess() {
    $.get("/cart", function (data) {
      var miniCartBodyHTML = $(data).find('.mini-cart-has-item').html();
      $('.mini-cart-has-item').html(miniCartBodyHTML);
      $('.cartDrawer').removeClass('is-empty');
      initSwiper();
    });
  }

  function refreshCart(cart) {
    var mf = "{{ shop.money_format }}";
    $('.cart-header .cart-price').text(Shopify.formatMoney(cart.original_total_price), mf);
    $('.cart-header .count').text(cart.item_count);
    $('.mini-cart-header .cart-tottl-itm').text(cart.item_count + ' Items');
  }

  function addToMainCartSuccess() {
    $.get("/cart", function (data) {
      var miniCartBodyHTML = $(data).find('cart-items').html();
      $('cart-items').html(miniCartBodyHTML);
      $('cart-items').removeClass('is-empty');
      var cart_total = $(data).find('.cart__blocks.subtotal .cart_price').html();
      $('.cart__blocks.subtotal .cart_price').html(cart_total);
    });
  }

  $('body').on('click', '.cart-btn', function (e) {
    e.preventDefault();
    var btn = $(this);
    $(btn).find('.loading-overlay__spinner').removeClass('hidden');
    $(btn).addClass('loading');

    const variant = $(this).closest('form').find('input[name="id"]').val();

    if (!variant) {
      console.error("Variant ID not found! Fix your HTML structure.");
      $(btn).find('.loading-overlay__spinner').addClass('hidden');
      $(btn).removeClass('loading');
      return;
    }

    let quantity = 1;
    if ($(this).parents('.products-add-cart-sticky.show-btn').length > 0) {
      quantity = $(this).parents('.sticky-pro-inner').find('.quantity__input').val();
    } else if ($(this).parents('.quickview_popup_data').length > 0) {
      quantity = $('.quickview_popup_data').find('.quantity__input').val();
    } else if ($(this).parents('.pdp-left-column').length > 0) {
      quantity = $(this).parents('.pdp-left-column').find('.quantity__input').val();
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variant, quantity: quantity },
      dataType: 'json',
      success: function () {
        addToCartSuccess();
        $(btn).find('.loading-overlay__spinner').addClass('hidden');
        $(btn).removeClass('loading');
        $('body').addClass('no-scroll cartOpen');
        $('.disclosure__list-wrapper').addClass('hide');
        $.getJSON("/cart.js", function (cart) {
          refreshCart(cart);
        });
      },
      error: function () {
        console.error("Error adding to cart.");
        $(btn).find('.loading-overlay__spinner').addClass('hidden');
        $(btn).removeClass('loading');
      }
    });
  });

  // Quantity update logic
  $(document).on('click', '.cart-item__quantity-wrapper .qty-spinner .quantity__button, .cartDrawer .quantity__button', function (e) {
    e.preventDefault();

    var id = parseInt($(this).siblings('input').attr('data-qid'));
    var ip = parseInt($(this).siblings('input').val());
    var cart_quan = $(this);

    ip = $(this).hasClass('quantity-increment') ? ip + 1 : ip - 1;
    if (ip === 0) return false;

    $(this).siblings('input').val(ip);

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + id + ']=' + ip,
      dataType: 'json',
      success: function (data) {
        cart_quan.hasClass('cart-quan') ? addToMainCartSuccess() : addToCartSuccess();
        $.getJSON("/cart.js", function (cart) {
          refreshCart(cart);
        });
      }
    });
  });

  // Remove item from cart
  $('body').on('click', 'cart-remove-button', function (e) {
    e.preventDefault();
    var id = $(this).find('a').data("id");
    var cart_button = $(this);

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: id,
        quantity: 0
      },
      dataType: "json",
      success: function (data) {
        if (cart_button.hasClass('cart-drawer-remove')) {
          if (data.item_count === 0) {
            $('.mini-cart-has-item').empty();
            $('.cartDrawer').addClass('is-empty');
            refreshCart(data);
          } else {
            addToCartSuccess();
            $.getJSON("/cart.js", function (cart) {
              refreshCart(cart);
            });
          }
        } else {
          if (data.item_count === 0) {
            $('#main-cart-items').empty();
            $('cart-items').addClass('is-empty');
            $('#main-cart-footer').addClass('is-empty');
            refreshCart(data);
          } else {
            addToMainCartSuccess();
            $.getJSON("/cart.js", function (cart) {
              refreshCart(cart);
            });
          }
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);
      }
    });
  });

  // Gift wrap button
  $('body').on("click", ".gift_wrap_btn", function (e) {
    e.preventDefault();
    const variant = $(this).closest('form').find('input[name="id"]').val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variant, quantity: 1 },
      dataType: 'json',
      success: function () {
        addToMainCartSuccess();
        $.getJSON("/cart.js", function (cart) {
          refreshCart(cart);
        });
      }
    });
  });

  // Gift wrap checkbox
  $('body').on("change", ".gift_wrap_check", function (e) {
    e.preventDefault();
    if ($(this).is(':checked')) {
      const variant = $(this).closest('form').find('input[name="id"]').val();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variant, quantity: 1 },
        dataType: 'json',
        success: function () {
          addToCartSuccess();
          $.getJSON("/cart.js", function (cart) {
            refreshCart(cart);
          });
          $('.gift-popup').removeClass('active');
        }
      });
    }
  });

});